<template>
  <AppDialog
    :is-open="isDialogOpened"
    :cancel-text="$t('common.close')"
    cancelOnly
    @cancel="closeDialog"
  >
    <template #title>
      {{ $t('project.documents.dialogs.DocumentsNotRedactableDialog.title') }}
    </template>

    <template #body>
      <p v-for="reason in reasons" :key="reason">
        {{ $t(`project.documents.dialogs.DocumentsNotRedactableDialog.reasons.${reason}`) }}
      </p>
    </template>
  </AppDialog>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import { dialogMixin } from '@/mixins/dialogMixin'

export default defineComponent({
  name: 'DocumentsNotRedactableDialog',
  components: { AppDialog },
  mixins: [dialogMixin],
  props: {
    reasons: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
})
</script>
